import { cloneElement, memo, useEffect, useRef } from 'react';
import { deserialize } from 'react-serialize';
import { useClickTracking } from '../../lib/REST/ApiTracking';
import { WebBlocksApiComponentT } from '../../lib/REST/types';

type ItemPropsType = {
	element: WebBlocksApiComponentT | string | null;
	onLinkClick?: (url: string) => Promise<unknown>;
	onRendered?: () => void;
};

function ItemComponent({
	element,
	onLinkClick = () => Promise.resolve(null),
	onRendered = () => {},
}: ItemPropsType) {
	const ref = useRef(null);
	const output = deserialize(element);

	useClickTracking(ref, onLinkClick);

	useEffect(onRendered);

	return cloneElement(output, { ref });
}

function propsAreEqual(prevProps: ItemPropsType, nextProps: ItemPropsType) {
	return (
		prevProps.element === nextProps.element &&
		prevProps.onLinkClick === nextProps.onLinkClick &&
		prevProps.onRendered === nextProps.onRendered
	);
}

export const Item = memo(ItemComponent, propsAreEqual);
